import { __, prop } from 'ramda';

import { FrequenciesEnum } from '../../../types/document';

enum PrismicFrequency {
  WEEKLY = 'hebdomadaire',
  ALWAYS = 'toujours',
  HOURLY = 'toutes les heures',
  DAILY = 'quotidienne',
  MONTHLY = 'mensuelle',
  YEARLY = 'annuelle',
  NEVER = 'jamais',
}

const MAPPER = {
  [PrismicFrequency.WEEKLY]: FrequenciesEnum.WEEKLY,
  [PrismicFrequency.ALWAYS]: FrequenciesEnum.ALWAYS,
  [PrismicFrequency.HOURLY]: FrequenciesEnum.HOURLY,
  [PrismicFrequency.DAILY]: FrequenciesEnum.DAILY,
  [PrismicFrequency.MONTHLY]: FrequenciesEnum.MONTHLY,
  [PrismicFrequency.YEARLY]: FrequenciesEnum.YEARLY,
  [PrismicFrequency.NEVER]: FrequenciesEnum.NEVER,
};

export const toFrequency = prop(__, MAPPER);
